import ActionSelector from '../../components/ActionSelector'
import { useModuleAction } from '../../hooks/useModuleAction'
import AddTxToStopListForm from './AddTxToStopListForm'
import { type StoplistAction } from './constants'
import RemoveTxFromStopListForm from './RemoveTxFromStopListForm'

export default function StoplistModule() {
  const { selectedAction, selectAction, isValidAction } =
    useModuleAction('stoplist')

  const formByAction = {
    add: AddTxToStopListForm,
    remove: RemoveTxFromStopListForm,
  } satisfies Record<StoplistAction, React.ComponentType>

  const Form = selectedAction ? formByAction[selectedAction] : null

  if (!isValidAction) {
    return <ActionSelector module='stoplist' onSelectAction={selectAction} />
  }

  return <div className='space-y-4'>{Form && <Form />}</div>
}
